// Textos da Equipe da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.equipe.acoes': 'Ações',
    'farm.equipe.excel': 'Excel',
    'farm.equipe.todos': 'Todos',
    'farm.equipe.todas': 'Todas',
    'farm.equipe.fechar': 'Fechar',
    'farm.equipe.naoInformado': 'Não informado',
    'farm.equipe.semResultado': 'Nada para mostrar com estes filtros.',
    'farm.equipe.busca': 'Buscar por nome, matrícula ou função',
    'farm.equipe.ajuda': 'O quadro vem do Protheus, pelo arquivo que o DP já carrega, e cada filial leva ao imóvel. Os cartões filtram por imóvel. O salário aparece só para quem tem a permissão de salário do DP.',
    'farm.equipe.fonte': 'Quadro do DP de {{data}}',
    'farm.equipe.kpi.total': 'Equipe inteira',
    'farm.equipe.col.pessoa': 'Pessoa',
    'farm.equipe.col.imovel': 'Imóvel',
    'farm.equipe.col.situacao': 'Situação',
    'farm.equipe.col.admissao': 'Admissão',
    'farm.equipe.col.salario': 'Salário',
    'farm.equipe.filtro.imovel': 'Imóvel',
    'farm.equipe.filtro.situacao': 'Situação',
    'farm.equipe.filtro.funcao': 'Função',
    'farm.equipe.situacao.ativo': 'Ativo',
    'farm.equipe.situacao.ferias': 'Férias',
    'farm.equipe.situacao.afastado': 'Afastado',
    'farm.equipe.ate': 'Volta em {{data}}',
    'farm.equipe.tempoAnos': '{{n}} anos de casa',
    'farm.equipe.tempoUmAno': '1 ano de casa',
    'farm.equipe.tempoMeses': '{{n}} meses de casa',
    'farm.equipe.tempoNovo': 'Menos de 1 mês',
    'farm.equipe.centro': 'Centro de custo {{c}}',
    'farm.equipe.ficha': 'Ficha',
    'farm.equipe.fichaDe': 'Ficha de {{nome}}',
    'farm.equipe.campo.matricula': 'Matrícula',
    'farm.equipe.campo.filial': 'Filial do Protheus',
    'farm.equipe.campo.funcao': 'Função',
    'farm.equipe.campo.imovel': 'Imóvel',
    'farm.equipe.campo.centro': 'Centro de custo',
    'farm.equipe.campo.admissao': 'Admissão',
    'farm.equipe.campo.situacao': 'Situação',
    'farm.equipe.campo.telefone': 'Telefone',
    'farm.equipe.campo.salario': 'Salário',
    'farm.equipe.doDp': 'Os dados são do DP e mudam pelo próximo quadro do Protheus.',
    'farm.equipe.compacto.pessoas': '{{n}} pessoas',
    'farm.equipe.compacto.umaPessoa': '1 pessoa',
    'farm.equipe.compacto.folha': 'Folha mensal',
    'farm.equipe.compacto.verTodos': 'Ver na Equipe',
    'farm.equipe.compacto.vazio': 'Ninguém do quadro está neste imóvel.',
    'farm.equipe.compacto.erro': 'Não foi possível carregar a equipe.',
  },
  en: {
    'farm.equipe.acoes': 'Actions',
    'farm.equipe.excel': 'Excel',
    'farm.equipe.todos': 'All',
    'farm.equipe.todas': 'All',
    'farm.equipe.fechar': 'Close',
    'farm.equipe.naoInformado': 'Not provided',
    'farm.equipe.semResultado': 'Nothing to show with these filters.',
    'farm.equipe.busca': 'Search by name, ID or role',
    'farm.equipe.ajuda': 'The roster comes from Protheus, in the file HR already loads, and each branch maps to a property. The cards filter by property. Salary shows only to people with the HR salary permission.',
    'farm.equipe.fonte': 'HR roster of {{data}}',
    'farm.equipe.kpi.total': 'Whole team',
    'farm.equipe.col.pessoa': 'Person',
    'farm.equipe.col.imovel': 'Property',
    'farm.equipe.col.situacao': 'Status',
    'farm.equipe.col.admissao': 'Hired',
    'farm.equipe.col.salario': 'Salary',
    'farm.equipe.filtro.imovel': 'Property',
    'farm.equipe.filtro.situacao': 'Status',
    'farm.equipe.filtro.funcao': 'Role',
    'farm.equipe.situacao.ativo': 'Active',
    'farm.equipe.situacao.ferias': 'On vacation',
    'farm.equipe.situacao.afastado': 'On leave',
    'farm.equipe.ate': 'Back on {{data}}',
    'farm.equipe.tempoAnos': '{{n}} years in the company',
    'farm.equipe.tempoUmAno': '1 year in the company',
    'farm.equipe.tempoMeses': '{{n}} months in the company',
    'farm.equipe.tempoNovo': 'Less than 1 month',
    'farm.equipe.centro': 'Cost center {{c}}',
    'farm.equipe.ficha': 'Record',
    'farm.equipe.fichaDe': 'Record of {{nome}}',
    'farm.equipe.campo.matricula': 'Employee ID',
    'farm.equipe.campo.filial': 'Protheus branch',
    'farm.equipe.campo.funcao': 'Role',
    'farm.equipe.campo.imovel': 'Property',
    'farm.equipe.campo.centro': 'Cost center',
    'farm.equipe.campo.admissao': 'Hired',
    'farm.equipe.campo.situacao': 'Status',
    'farm.equipe.campo.telefone': 'Phone',
    'farm.equipe.campo.salario': 'Salary',
    'farm.equipe.doDp': 'This data belongs to HR and changes with the next Protheus roster.',
    'farm.equipe.compacto.pessoas': '{{n}} people',
    'farm.equipe.compacto.umaPessoa': '1 person',
    'farm.equipe.compacto.folha': 'Monthly payroll',
    'farm.equipe.compacto.verTodos': 'Open in Team',
    'farm.equipe.compacto.vazio': 'Nobody on the roster works on this property.',
    'farm.equipe.compacto.erro': 'Could not load the team.',
  },
  es: {
    'farm.equipe.acoes': 'Acciones',
    'farm.equipe.excel': 'Excel',
    'farm.equipe.todos': 'Todos',
    'farm.equipe.todas': 'Todas',
    'farm.equipe.fechar': 'Cerrar',
    'farm.equipe.naoInformado': 'No informado',
    'farm.equipe.semResultado': 'Nada para mostrar con estos filtros.',
    'farm.equipe.busca': 'Buscar por nombre, legajo o función',
    'farm.equipe.ajuda': 'La nómina viene de Protheus, en el archivo que RR. HH. ya carga, y cada sucursal lleva al inmueble. Las tarjetas filtran por inmueble. El salario aparece solo para quien tiene el permiso de salario de RR. HH.',
    'farm.equipe.fonte': 'Nómina de RR. HH. del {{data}}',
    'farm.equipe.kpi.total': 'Equipo completo',
    'farm.equipe.col.pessoa': 'Persona',
    'farm.equipe.col.imovel': 'Inmueble',
    'farm.equipe.col.situacao': 'Situación',
    'farm.equipe.col.admissao': 'Ingreso',
    'farm.equipe.col.salario': 'Salario',
    'farm.equipe.filtro.imovel': 'Inmueble',
    'farm.equipe.filtro.situacao': 'Situación',
    'farm.equipe.filtro.funcao': 'Función',
    'farm.equipe.situacao.ativo': 'Activo',
    'farm.equipe.situacao.ferias': 'Vacaciones',
    'farm.equipe.situacao.afastado': 'De baja',
    'farm.equipe.ate': 'Vuelve el {{data}}',
    'farm.equipe.tempoAnos': '{{n}} años en la empresa',
    'farm.equipe.tempoUmAno': '1 año en la empresa',
    'farm.equipe.tempoMeses': '{{n}} meses en la empresa',
    'farm.equipe.tempoNovo': 'Menos de 1 mes',
    'farm.equipe.centro': 'Centro de costo {{c}}',
    'farm.equipe.ficha': 'Ficha',
    'farm.equipe.fichaDe': 'Ficha de {{nome}}',
    'farm.equipe.campo.matricula': 'Legajo',
    'farm.equipe.campo.filial': 'Sucursal de Protheus',
    'farm.equipe.campo.funcao': 'Función',
    'farm.equipe.campo.imovel': 'Inmueble',
    'farm.equipe.campo.centro': 'Centro de costo',
    'farm.equipe.campo.admissao': 'Ingreso',
    'farm.equipe.campo.situacao': 'Situación',
    'farm.equipe.campo.telefone': 'Teléfono',
    'farm.equipe.campo.salario': 'Salario',
    'farm.equipe.doDp': 'Los datos son de RR. HH. y cambian con la próxima nómina de Protheus.',
    'farm.equipe.compacto.pessoas': '{{n}} personas',
    'farm.equipe.compacto.umaPessoa': '1 persona',
    'farm.equipe.compacto.folha': 'Nómina mensual',
    'farm.equipe.compacto.verTodos': 'Ver en Equipo',
    'farm.equipe.compacto.vazio': 'Nadie de la nómina trabaja en este inmueble.',
    'farm.equipe.compacto.erro': 'No se pudo cargar el equipo.',
  },
}
